export default "__VITE_ASSET__ozSOUKG2__"